// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import store from './store/store'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import axios from 'axios'
import { post, get } from './http/http'
import commonfun from '@/util/commonjs'
import api from './http/api'
import qs from 'qs';
Vue.config.productionTip = false
 import BaiduMap from 'vue-baidu-map'

 Vue.use(BaiduMap, {
//   // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
   ak:  '9aV9lMwHBbAktSKxpnG6ADMqXEv2p8iV'
 });

Vue.use(Vuex)
/* eslint-disable no-new */
Vue.prototype.$axios = axios
Vue.prototype.$get = get;
Vue.prototype.$post = post
// Vue.prototype.$login = login
Vue.prototype.$api = api
Vue.prototype.$store = store
Vue.prototype.commonfun=commonfun

Vue.prototype.$qs = qs
Vue.use(VueAwesomeSwiper, /* { default global options } */)
Vue.use(ElementUI);
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js